import * as yup from "yup";

export const CreateFarmerInventoryScheama = yup.object().shape({
  productId: yup.string().required("Product is required"),
  variantId: yup.number(),
  quantity: yup.number(),
});

export const UpdateFarmerInventoryScheama = yup.object().shape({
  quantity: yup.number().required("Quantity is number"),
});

export const AddItemHydroponicMaterial = yup.object().shape({
  inStock: yup.number().required("In Stock is required"),
  cost: yup.number().required("Cost is required"),
  costFromVendor: yup.string(),
  invoiceNumber: yup.string(),
});
